let currentTenant: string | null = null;

export const setTenantHeader = (tenant: string | null) => {
  currentTenant = tenant;
};

export const getTenantHeader = () => {
  return currentTenant;
};
